module.exports = __webpack_public_path__ + "img/anzhen.070cd3b4.png";